// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseComponent } from '../../../../../com/MetaPattern/MDA/MD/Base/BaseComponent';
import { ProductComment } from './ProductComment';
import { ProductAPP } from './ProductAPP';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { ProductComponentExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/ProductModel/ProductComponentExtend';
/**
 * 产品模型组件 实体类
 * 产品模型组件，定义产品模型
 */
export class ProductComponent extends BaseComponent {
  /** 注释 */
  private _comments: Array<ProductComment>;

  /** 获取：注释 */
  public get comments() {
    return this._comments;
  }

  /** 设置：注释 */
  public set comments(value: Array<ProductComment>) {
    this._comments = value;
  }

  /** 产品应用 */
  private _productAPPs: Array<ProductAPP>;

  /** 获取：产品应用 */
  public get productAPPs() {
    return this._productAPPs;
  }

  /** 设置：产品应用 */
  public set productAPPs(value: Array<ProductAPP>) {
    this._productAPPs = value;
  }

  constructor() {
    super();
    ProductComponentExtend.Init(this);
    this._comments = new Array<ProductComment>();
    this._productAPPs = new Array<ProductAPP>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ProductComponent, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    if (json.Comments && json.Comments.length > 0) {
      json.Comments.forEach((element: any) => {
        const productComment = ProductComment.Create(element);
        // productComment.component = this;
        this.comments.push(productComment);
      });
    }
    if (json.ProductAPPs && json.ProductAPPs.length > 0) {
      json.ProductAPPs.forEach((element: any) => {
        const productAPP = ProductAPP.Create(element);
        // productAPP.component = this;
        this.productAPPs.push(productAPP);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    if (this.comments && this.comments.length > 0) {
      json.Comments = [];
      this.comments.forEach((element) => {
        json.Comments.push(element.toJson());
      });
    }
    if (this.productAPPs && this.productAPPs.length > 0) {
      json.ProductAPPs = [];
      this.productAPPs.forEach((element) => {
        json.ProductAPPs.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): ProductComponent {
    const productComponent = new ProductComponent();
    productComponent.Deserialize(json);
    productComponent.json = json;
    return productComponent;
  }
}
